import { render, staticRenderFns } from "./TemplateItemFormulaModal.vue?vue&type=template&id=526ab6c3&scoped=true"
import script from "./TemplateItemFormulaModal.vue?vue&type=script&lang=js"
export * from "./TemplateItemFormulaModal.vue?vue&type=script&lang=js"
import style0 from "./TemplateItemFormulaModal.vue?vue&type=style&index=0&id=526ab6c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526ab6c3",
  null
  
)

export default component.exports